import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import AppRoutes from './routes/AppRoutes';
import Loader from './components/common/Loader';
import ScrollToTop from './components/common/ScrollToTop';

import './styles/animations.css';

function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 overflow-x-hidden selection:bg-cyan-400 selection:text-slate-950">
      <ScrollToTop />

      <Suspense
        fallback={
          <div className="flex items-center justify-center min-h-screen">
            <Loader />
          </div>
        }
      >
        <Routes>
          <Route path="/*" element={<AppRoutes />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;